import dayjs from 'dayjs'

export function formatTimestampDate(timestamp: string | null): string | null {
  if (!timestamp) return null

  const date = dayjs.unix(Number(timestamp))
  if (!date.isValid()) return timestamp

  return date.format('MMM D, YYYY')
}
